import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StatusPill } from "@/components/StatusPill";
import { useI18n } from "@/i18n/I18nContext";
import { GitBranch, Loader2 } from "lucide-react";

export default function Decisions() {
  const [items, setItems] = useState(null);
  const { t } = useI18n();
  useEffect(() => { api.decisions().then(setItems); }, []);
  if (!items) return <div className="flex items-center justify-center py-32"><Loader2 className="animate-spin text-[#2563EB]" /></div>;
  return (
    <div className="space-y-6">
      <div>
        <p className="mono-label">{t("dec.label")}</p>
        <h1 className="font-display text-3xl font-extrabold text-white mt-1 flex items-center gap-2"><GitBranch className="text-[#2563EB]" /> {t("dec.title")}</h1>
        <p className="text-sm text-[#94A3B8] mt-1">{t("dec.subtitle")}</p>
      </div>
      <div className="relative pl-6">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-[#1E293B]" />
        <div className="space-y-4">
          {items.map((d) => (
            <div key={d.id} className="relative" data-testid={`decision-${d.id}`}>
              <div className="absolute -left-[22px] top-2 h-3.5 w-3.5 rounded-full bg-[#2563EB] border-2 border-[#070A12]" />
              <div className="m-card p-5">
                <div className="flex items-center justify-between gap-2 flex-wrap"><p className="text-white font-semibold">{d.title}</p><div className="flex items-center gap-2"><span className="mono-label">{d.project_code}</span><StatusPill status="APPROVED" label={d.status} /></div></div>
                <p className="text-sm text-[#94A3B8] mt-2">{d.context}</p>
                <div className="flex flex-wrap gap-2 mt-3">{(d.options || []).map((o) => <span key={o} className={`m-pill ${o === d.chosen_decision ? "text-[#6EE7B7]" : "text-[#64748B]"}`} style={{ borderColor: o === d.chosen_decision ? "#10B981" : "#1E293B", background: "#0B0F19" }}>{o}{o === d.chosen_decision ? " ✓" : ""}</span>)}</div>
                <p className="text-xs text-[#E2E8F0] mt-3"><span className="text-[#64748B]">{t("dec.rationale")}</span> {d.rationale}</p>
                <p className="text-[10px] text-[#64748B] font-mono mt-2">{t("dec.byMaker", { v: d.decision_maker })} · {new Date(d.created_at).toLocaleString()}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
